var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-items-center justify-content-center p-1"},[(_vm.item.enabled)?_c('b-icon',{staticClass:"text-success",attrs:{"icon":"check-lg"}}):_c('b-icon',{staticClass:"text-danger",attrs:{"icon":"x-lg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }